module.exports = __webpack_public_path__ + "img/close.bc21741c.svg";